import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Form } from 'semantic-ui-react';
import _ from 'lodash';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { VendorEleFileConfigFieldEnum as Fields } from 'Common/FieldEnum';

class CustomerInfoContainer extends Component {
  handleCustomerIdChange = (refData, newValue) => {
    const currentFields = this.props.input.value;
    const newFields = [];
    let found = false;
    _.each(currentFields, field => {
      const newFiled = Object.assign({}, field);
      if (refData[Fields.SiteId] === newFiled[Fields.SiteId]) {
        found = true;
        newFiled[Fields.VendorsSiteId] = newValue;
      }
      newFields.push(newFiled);
    });
    if (!found && newValue && newValue.trim().length > 0) {
      const newFiled = {};
      newFiled[Fields.SiteId] = refData[Fields.SiteId];
      newFiled[Fields.VendorsSiteId] = newValue;
      newFields.push(newFiled);
    }
    this.props.input.onChange(newFields);
  };

  handleContractIdChange = (refData, newValue) => {
    const currentFields = this.props.input.value;
    const newFields = [];
    let found = false;
    _.each(currentFields, field => {
      const newFiled = Object.assign({}, field);
      if (refData[Fields.SiteId] === newFiled[Fields.SiteId]) {
        found = true;
        newFiled[Fields.VendorsContractId] = newValue;
      }
      newFields.push(newFiled);
    });
    if (!found && newValue && newValue.trim().length > 0) {
      const newFiled = {};
      newFiled[Fields.SiteId] = refData[Fields.SiteId];
      newFiled[Fields.VendorsContractId] = newValue;
      newFields.push(newFiled);
    }
    this.props.input.onChange(newFields);
  };

  handleCustomerIdBlur = refData => {
    const currentFields = this.props.input.value;
    const newFields = [];
    let shouldRemove = false;
    _.each(currentFields, field => {
      shouldRemove = false;
      const newFiled = Object.assign({}, field);
      if (refData[Fields.SiteId] === newFiled[Fields.SiteId]) {
        if (refData[Fields.VendorsSiteId].trim().length > 0) {
          if (
            !newFiled[Fields.VendorsContractId] ||
            newFiled[Fields.VendorsContractId].trim().length <= 0
          ) {
            newFiled[Fields.VendorsContractId] = refData[Fields.VendorsSiteId];
          }
        } else {
          shouldRemove = true;
        }
      }
      if (!shouldRemove) {
        newFields.push(newFiled);
      }
    });
    this.props.input.onChange(newFields);
  };

  handleOnContractIdBlur = refData => {
    const currentFields = this.props.input.value;
    const newFields = [];
    _.each(currentFields, field => {
      const newFiled = Object.assign({}, field);
      if (refData[Fields.SiteId] === newFiled[Fields.SiteId]) {
        if (refData[Fields.VendorsContractId].trim().length > 0) {
          if (
            !newFiled[Fields.VendorsSiteId] ||
            newFiled[Fields.VendorsSiteId].trim().length <= 0
          ) {
            newFiled[Fields.VendorsSiteId] = refData[Fields.VendorsContractId];
          }
        }
      }
      newFields.push(newFiled);
    });
    this.props.input.onChange(newFields);
  };
  getColumns = () => {
    return [
      {
        Header: 'Site Id',
        accessor: 'SiteId',
        filterable: false,
        resizable: false,
        width: 350,
        sortable: false,
      },
      {
        Header: 'Distributors Customer Id',
        sortable: true,
        accessor: 'VendorsSiteId',
        filterable: false,
        resizable: false,
        width: 350,
        Cell: ({ original }) => {
          return (
            <EditableLabel
              label={original[Fields.VendorsSiteId]}
              refData={original}
              onChange={this.handleCustomerIdChange}
              onBlur={this.handleCustomerIdBlur}
              maxLength={9}
              allowEdit={true}
            />
          );
        },
      },
      {
        Header: 'Distributors Contract Id',
        accessor: 'VendorsContractId',
        sortable: true,
        filterable: false,
        resizable: false,
        Cell: ({ original }) => {
          return (
            <EditableLabel
              label={original[Fields.VendorsContractId]}
              refData={original}
              onChange={this.handleContractIdChange}
              onBlur={this.handleOnContractIdBlur}
              maxLength={9}
              allowEdit={true}
            />
          );
        },
      },
    ];
  };

  prepareTableData = () => {
    const { dataSource } = this.props;
    const { value } = this.props.input;
    const tableData = [];
    if (dataSource && dataSource.length > 0) {
      _.each(dataSource, siteId => {
        const dataRow = {};
        dataRow[Fields.SiteId] = siteId;
        const index = _.findIndex(value, { [Fields.SiteId]: siteId });
        if (index >= 0 && index < value.length) {
          const infoObj = value[index];
          dataRow[Fields.VendorsSiteId] = infoObj[Fields.VendorsSiteId];
          dataRow[Fields.VendorsContractId] = infoObj[Fields.VendorsContractId];
        }
        tableData.push(dataRow);
      });
    }
    return tableData;
  };

  render() {
    const tableData = this.prepareTableData();
    return (
      <Form.Field>
        <ReactTable
          getTdProps={() => ({
            style: {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
          })}
          minRows={0}
          columns={this.getColumns()}
          data={tableData}
          showPagination={false}
          defaultPageSize={
            tableData && Array.isArray(tableData) ? tableData.length : 0
          }
          style={{
            height: '300px',
          }}
          sortable={true}
        />
      </Form.Field>
    );
  }
}

export default CustomerInfoContainer;



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/CustomerInfo.js